// extracted by mini-css-extract-plugin
export var legendIndicator = "_ez-1";
export var legendRight = "_ez-0";